import Cookies from "js-cookie";
import modal from "@frontend/scripts/components/modal";

export default {
  init: async () => {
    const overlayUrl = document.body.dataset.pageOverlayUrl;
    const overlayCookie = document.body.dataset.pageOverlayCookie;

    if (overlayUrl) {
      modal.openModal({
        type: "content",
        url: overlayUrl,
      });

      if (parseInt(overlayCookie) === 1) {
        Cookies.set("seenpageoverlay", true, { expires: 1 });
      }
    }
  },
};
